import React, { useEffect, useImperativeHandle, useState ,forwardRef} from "react";
import { 
	RCCGrid, 
	RCCServicesApi,
	RCCHookToast,
	RCCCheckBox
} from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import Accordion from "src/components/Accordion";
import Loader from "src/components/Loader";
import { v4 } from "uuid";
import useEffectSkipInitialRender from "src/hooks/useEffectSkipInitialRender";
import { IEftba005, IRefUsersGrouper, IUsersGrouper } from "../interface";
import UsersListGrouper from "./listGrouper";

const UserGrouper: React.ForwardRefRenderFunction<IRefUsersGrouper,IUsersGrouper> = ({
	disabled,
	grouper,
	setSelectedUsersList
},ref) => { 

	const { translate } = useTranslation();
	const {addToast} = RCCHookToast();
	
	const [usersList,setUsersList] =  useState<Array<IEftba005>>();
	const [loading, setLoading] = useState(false);
	const [reQuery,setReQuery] = useState(true);
	const [expandedAccordion, setExpandedAccordion] = useState(false);
	const [checkAll,setCheckAll] = useState(false);

	const handleAccordion = (expanded:boolean) => {
		setExpandedAccordion(expanded);
		if(!expanded || !reQuery)
			return;
		executeQuery();
		setReQuery(false);
	};

	const executeQuery = async() => {
		setLoading(true);
		try {
			const dataController = await RCCServicesApi.getRequest({
				method: "User/List",
				urlParameters: {
					group: grouper.efa004Id,
					enabledUsers: true
				}
			});
			setUsersList(dataController.data.listRecords);
			setLoading(false);

		} catch (error) {
			standardErrorMessages(error, translate("Erro ao buscar usuários"), addToast);
			setLoading(false);
		}
	};

	const handleSelectedAll = (setAll:boolean) => setUsersList((prevState) => prevState?.map((x) => ({...x,selected:setAll})));

	const forceRequery = () => {
		setExpandedAccordion(false);
		setCheckAll(false);
		setReQuery(true);
	};
	
	const getSelectedUsers = () => usersList?.filter((x) => x.selected)||[];

	const cleanSelectedUsers = (remove:boolean = true) => {
		if(remove)
			setUsersList((prevState) => prevState?.filter((x) => !x.selected));
		else if(checkAll)
			setCheckAll(false);
		else
			setUsersList((prevState) => prevState?.map((x) => (x.selected ? {...x,selected:!x.selected} : x)));
	};
	
	const queryAndSellectAll = async () => {
		await executeQuery();
		setReQuery(false);
		setCheckAll((prevstate) => !prevstate);
	};

	useImperativeHandle(ref,() => ({
		getSelectedUsers,
		cleanSelectedUsers,
		forceRequery
	}));

	useEffect(() => {
		forceRequery();
	}, []);

	useEffect(() => {
		handleSelectedAll(checkAll);
	}, [checkAll]);


	useEffectSkipInitialRender(() => {
		const usersSelected = getSelectedUsers();
		setSelectedUsersList((prevState) => {
			const newState = prevState && prevState.length > 0  ? prevState.filter((e) => e.group !== grouper.efa004Id): [];
			const newUsers = usersSelected && usersSelected.length > 0 ? usersSelected?.map((x) => ({
				...x,
				group: grouper.efa004Id
			})): [];
			
			return [
				...newState,
				...newUsers
			];
		});
	},[usersList]);

	return (
		<Accordion 
			expanded={disabled ? false : expandedAccordion}
			onChange={(_, expanded) => handleAccordion(expanded)}
			TransitionProps={{ unmountOnExit: true }} 
			disabled={disabled}
			header={
				<RCCGrid container 
					spacing={2} 
					wrap="nowrap"
				>
					<RCCCheckBox
						name={`selectAllUserGroup-${v4()}`}
						onClick={() => {
							if(reQuery){
								queryAndSellectAll();
								return;
							}
							setCheckAll((prevstate) => !prevstate);
						}}
						defaultChecked={checkAll}
						useStopPropagation
					/>
					<RCCGrid container item 
						justifyContent="space-between" 
						alignContent="center"
					>
						<span style={{alignSelf:"center"}}>
							{grouper.efa004Descricao}
						</span>
					</RCCGrid>
				</RCCGrid>
			}
		>
			{loading ? 
				<Loader/>
				:
				<UsersListGrouper 
					usersList={usersList}
					setUsersList={setUsersList}
				/>
			}
		</Accordion>
	);
};

export default forwardRef(UserGrouper);
